import axios from "axios";
import {
  ADD_TO_CART,
  EMPTY_CART_REQUEST,
  REMOVE_ITEM_CART,
  REMOVIE_ITEM_CART,
  SAVE_SHIPPING_INFO,
  //   SAVE_SHIPPING_INFO,
} from "../constants/cartConstants";

export const addItemToCart = (id, quantity) => async (dispatch, getState) => {
  const config = {
    withCredentials: "true",
  };
  const { data } = await axios.get(
    `https://ebuymait.herokuapp.com/api/v1/product/${id}`,
    config,
  );

  dispatch({
    type: ADD_TO_CART,
    payload: {
      product: data.product._id,
      name: data.product.name,
      price: data.product.price,
      image: data.product.images[0].url,
      stock: data.product.stock,
      quantity,
    },
  });

  localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems));
};

export const removeItemFromCart = (id) => async (dispatch, getState) => {
  dispatch({
    type: REMOVIE_ITEM_CART,
    payload: id,
  });

  localStorage.setItem("cartItems", JSON.stringify(getState().cart.cartItems));
};
export const emptyCart = () => async (dispatch) => {
  localStorage.removeItem("cartItems");
  dispatch({
    type: EMPTY_CART_REQUEST,
  });
};
export const saveShippingInfo = (data) => async (dispatch) => {
  console.log("hahaha", data);
  dispatch({
    type: SAVE_SHIPPING_INFO,
    payload: data,
  });

  localStorage.setItem("shippingInfo", JSON.stringify(data));
};
